// PLA.jsx
import React from "react";
import PageLayout from '../../Components/PageLayout';

function PLA() {
    return (
        <PageLayout title="PLA" subtitle="PLA overview">
            <div className="container flex col box-container">
                {/* <div className="box">PLA</div> */}
            </div>
        </PageLayout>   
    );
}

export default PLA;
